import { render, staticRenderFns } from "./ProductosAYBForm.vue?vue&type=template&id=68776102"
import script from "./ProductosAYBForm.vue?vue&type=script&lang=js"
export * from "./ProductosAYBForm.vue?vue&type=script&lang=js"
import style0 from "./ProductosAYBForm.vue?vue&type=style&index=0&id=68776102&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports